import {
  Box,
  Chip,
  Dialog,
  Grid,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import DatePicker from "../../../components/common/DatePicker";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import CheckBoxInput from "../../../components/common/CheckboxInput";
import JobDetailScheduleConfig from "./JobDetailScheduleConfig";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import { ModalContent, ModalFooter } from "./ExcludeModal";

const JobDetailInputData = (props) => {
  const [openBoxModal, setOpenBoxModal] = useState(false);
  const [selectedBoxDetails, setSelectedBoxDetails] = useState({});
  const getJobDetailsData = useSelector((state) => state?.getJobInputDetail);
  const plant = localStorage.getItem("selectedLTPlantCode");
  const { singleDropdownData } = props;

  const renderTextField = (value) => {
    return (
      <TextField
        id="outlined-read-only-input"
        sx={{
          "& .MuiOutlinedInput-root": {
            height: 40,
            width: 200,
          },
        }}
        freeSolo
        defaultValue={value}
        value={value}
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />
    );
  };

  const handleClickInside = (mappedData, name) => {
    setOpenBoxModal(true);
    setSelectedBoxDetails({ mappedData: mappedData, name: name });
  };

  const handleCloseBoxModel = () => {
    setOpenBoxModal(false);
    setSelectedBoxDetails({ mappedData: {}, name: "" });
  };

  const renderBoxItems = (mappedData, name) => {
    const isDisabled = !mappedData || mappedData?.length === 0;
    return (
      <div>
        <Box
          onClick={
            !isDisabled ? () => handleClickInside(mappedData, name) : undefined
          }
          style={{
            height: "50px",
            width: "180px",
            display: "flex",
            overflowY: "auto",
            flexWrap: "wrap",
            gap: "4px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            transition: "all 0.3s ease",
            cursor: isDisabled ? "default" : "pointer",
            backgroundColor: isDisabled ? "#f0f0f0" : "white",
            opacity: isDisabled ? 0.6 : 1,
          }}
        >
          {mappedData?.map((option, index) => (
            <Chip label={option} key={index} />
          ))}
        </Box>
      </div>
    );
  };

  return (
    <>
      <form>
        <Grid
          container
          xs={12}
          sx={{
            border: "1px solid gray",
            padding: "0 15px",
            borderRadius: "10px",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div>
            <div style={{ padding: "10px 10px 0 10px" }}>
              <div className="row-1">
                <div>
                  <p>Plant</p>
                  {renderTextField(plant)}
                </div>
                <div>
                  <p>Purchasing Group</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.purchasingGroups,
                    "Purchasing Group"
                  )}
                </div>
                <div>
                  <p>MRP Controller</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.mrpControllers,
                    "MRP Controller"
                  )}
                </div>
                <div>
                  <p>S-Code (Ext Material Group)</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.scodes,
                    "S-Code (Ext Material Group)"
                  )}
                </div>
                <div>
                  <p>Supplier Code</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.supplierIds,
                    "Supplier Code"
                  )}
                </div>
              </div>
              <div className="row-1">
                <div>
                  <p>Supplier Name</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.supplierNames,
                    "Supplier Name"
                  )}
                </div>
                <div>
                  <p>Material Group</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.materialGroups,
                    "Material Group"
                  )}
                </div>
                <div>
                  <p>Material Type</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.materialTypes,
                    "Material Type"
                  )}
                </div>
                <div>
                  <p>Material</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.materialIds,
                    "Material"
                  )}
                </div>
                <div>
                  <p>Mode of Transport</p>
                  {renderBoxItems(
                    getJobDetailsData?.data?.modeOfTransports,
                    "Mode of Transport"
                  )}
                </div>
              </div>
            </div>
            <Dialog
              open={openBoxModal}
              onClose={handleCloseBoxModel}
              className="dialogBoxModal_viewAll"
              key={selectedBoxDetails?.name}
            >
              <DialogTitle>{`${selectedBoxDetails?.name} (${selectedBoxDetails?.mappedData?.length})`}</DialogTitle>
              <DialogContent sx={{ maxHeight: "300px", overflowY: "auto" }}>
                {selectedBoxDetails?.mappedData?.length > 0 ? (
                  selectedBoxDetails?.mappedData?.map((option, index) => (
                    <Chip key={index} label={option} sx={{ margin: "4px" }} />
                  ))
                ) : (
                  <p>No items selected</p>
                )}
              </DialogContent>
              <DialogActions>
                <ButtonComponent
                  onClick={handleCloseBoxModel}
                  type="primary"
                  label="Close"
                />
              </DialogActions>
            </Dialog>
          </div>
          <Grid container spacing={2}>
            <Grid item md={8} xs={12} sx={{ marginTop: "7px" }}>
              <label className="label-position" htmlFor="period-to-consider">
                Period To Consider*
              </label>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  paddingTop: "5px !important",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                }}
              >
                <Grid item md={4} xs={12}>
                  <DatePicker
                    name="fromDate"
                    label="Select From Date*"
                    value={dayjs(props.formData?.fromDate)}
                    onChange={(e) => props.handleDateChange(e, "fromDate")}
                    maxDate={singleDropdownData?.toDate}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <DatePicker
                    name="toDate"
                    label="Select To Date*"
                    value={dayjs(props.formData?.toDate)}
                    onChange={(e) => props.handleDateChange(e, "toDate")}
                    minDate={singleDropdownData?.fromDate}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                "& .MuiFormControl-root": { width: "80%" },
                "& .MuiFormLabel-root": { fontSize: "14px" },
                "& .MuiInputBase-root": { height: "90%" },
                "& .MuiFormControlLabel-root": { marginRight: "0" },
              }}
            >
              <CheckBoxInput
                props={{
                  name: "excludeRange",
                  checked: getJobDetailsData?.data?.excludeRanges.length
                    ? true
                    : props.formData?.excludeRange,
                  fontSize: 22,
                  onchange: props.handleChange,
                }}
              />
              <label className="label-position" htmlFor="period-to-consider">
                Exclude Range in the Period Selected
              </label>
            </Grid>
            {!getJobDetailsData?.data?.excludeRanges.length ? (
              props.formData?.excludeRange && (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    paddingTop: "0 !important",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    "& .MuiFormControl-root": { width: "80%" },
                    "& .MuiFormLabel-root": { fontSize: "14px" },
                    "& .MuiInputBase-root": { height: "90%" },
                    "& .MuiFormControlLabel-root": { marginRight: "0" },
                  }}
                >
                  <textarea
                    rows={5}
                    style={{ width: "100%", maxWidth: "400px", resize: "none" }}
                    disabled
                    value={
                      props.rows &&
                      props.rows?.map((row) => {
                        return `<${row?.range} From ${
                          row.excludeFromDate
                            ? dayjs(row.excludeFromDate).format("YYYY-MM-DD")
                            : null || "Date"
                        } To ${
                          row.excludeToDate
                            ? dayjs(row.excludeToDate).format("YYYY-MM-DD")
                            : null || "Date"
                        }>`;
                      })
                    }
                  />
                  <EditIcon
                    sx={{
                      cursor: "pointer",
                      border: "1.4px solid #ccc",
                      marginLeft: "5px",
                      borderRadius: "5px",
                    }}
                    onClick={props.handleEditRange}
                  />
                </Grid>
              )
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  paddingTop: "0 !important",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                  "& .MuiInputBase-root": { height: "90%" },
                  "& .MuiFormControlLabel-root": { marginRight: "0" },
                }}
              >
                <textarea
                  rows={5}
                  style={{ width: "100%", maxWidth: "400px", resize: "none" }}
                  disabled
                  value={
                    getJobDetailsData?.data?.excludeRanges &&
                    getJobDetailsData?.data?.excludeRanges?.map((row, key) => {
                      return `Range <${key + 1} From ${
                        row.excludeFrom
                          ? dayjs(row.excludeFrom).format("YYYY-MM-DD")
                          : null || "Date"
                      } To ${
                        row.excludeTo
                          ? dayjs(row.excludeTo).format("YYYY-MM-DD")
                          : null || "Date"
                      }>`;
                    })
                  }
                />
                <EditIcon
                  sx={{
                    cursor: "pointer",
                    border: "1.4px solid #ccc",
                    marginLeft: "5px",
                    borderRadius: "5px",
                  }}
                  onClick={props.handleEditRange}
                />
              </Grid>
            )}
          </Grid>
          <JobDetailScheduleConfig
            scheduleType={props?.scheduleType}
            scheduleValue={props.scheduleValue}
            setScheduleValue={props.setScheduleValue}
            formData={props.formData}
            handleChange={props.handleChange}
            scheduledTime={props.scheduledTime}
            setScheduledTime={props.setScheduledTime}
            scheduledStartDate={props.scheduledStartDate}
            setScheduledStartDate={props.setScheduledStartDate}
            setBtnDisabled={props.setBtnDisabled}
            minFromDate={props?.fromDate}
            maxToDate={props?.toDate}
          />
        </Grid>
      </form>
      {
        <Modal
          open={props.showModal}
          handleClose={props.handleClose}
          title="Exclude Range in Period Selected"
          action={
            <ModalFooter
              clearAllExcludeModal={props.clearAllExcludeModal}
              submitExcludeModalHandler={props.submitExcludeModalHandler}
              isModalBtnDisabled={props.isModalBtnDisabled}
              excludeModalBtnDisabled={props.excludeModalBtnDisabled}
            />
          }
          content={
            <ModalContent
              rows={props.rows || getJobDetailsData?.data?.excludeRanges}
              handleAddRows={props.handleAddRows}
              delRowHandler={props.delRowHandler}
              handleExcludeDateChange={props.handleExcludeDateChange}
              excludeModalBtnDisabled={props.excludeModalBtnDisabled}
              minFromDate={props?.fromDate}
              maxToDate={props?.toDate}
            />
          }
        />
      }
    </>
  );
};

export default JobDetailInputData;
